// utils/api/CodeEditorApi.js
// HTTP API for Code Editor operations

import { apiCall } from './ApiUtils';

export const codeEditorApi = {
  // Project and file retrieval
  getUserProjects: (classContext = null) => {
    // Use public endpoint for public users
    if (classContext?.is_public_view) {
      return apiCall(`/code-editor/public/projects?class_id=${classContext?.class_id}`, {
        method: 'GET'
      }, classContext);
    }
    return apiCall(`/code-editor/projects?class_id=${classContext?.class_id}`, {
      method: 'GET'
    }, classContext);
  },

  getFile: (fileId, classContext = null) =>
    apiCall(`/code-editor/files/${fileId}?class_id=${classContext?.class_id}`, {
      method: 'GET'
    }, classContext),

  getSupportedLanguages: () =>
    apiCall('/code-editor/languages', {
      method: 'GET'
    }),

  // Project operations
  createProject: (projectName, runtimeLanguage, description, classContext = null) =>
    apiCall('/code-editor/projects', {
      method: 'POST',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        project_name: projectName,
        runtime_language: runtimeLanguage,
        description
      })
    }, classContext),

  // File operations
  createFile: (filename, content = '', projectId = null, classContext = null) =>
    apiCall('/code-editor/files', {
      method: 'POST',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        filename,
        content,
        project_id: projectId
      })
    }, classContext),

  updateFile: (fileId, content, changeType = 'manual_edit', classContext = null) =>
    apiCall(`/code-editor/files/${fileId}`, {
      method: 'PUT',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        content,
        change_type: changeType
      })
    }, classContext),

  moveFile: (fileId, newProjectId, classContext = null) =>
    apiCall(`/code-editor/files/${fileId}/move`, {
      method: 'PUT',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        project_id: newProjectId
      })
    }, classContext),

  deleteFile: (fileId, classContext = null) =>
    apiCall(`/code-editor/files/${fileId}?class_id=${classContext?.class_id}`, {
      method: 'DELETE'
    }, classContext),

  archiveFile: (fileId, classContext = null) =>
    apiCall(`/code-editor/files/${fileId}/archive?class_id=${classContext?.class_id}`, {
      method: 'PUT'
    }, classContext),

  unarchiveFile: (fileId, classContext = null) =>
    apiCall(`/code-editor/files/${fileId}/unarchive?class_id=${classContext?.class_id}`, {
      method: 'PUT'
    }, classContext),

  archiveProject: (projectId, archiveFiles = true, classContext = null) =>
    apiCall(`/code-editor/projects/${projectId}/archive`, {
      method: 'PUT',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        archive_files: archiveFiles
      })
    }, classContext),

  unarchiveProject: (projectId, unarchiveFiles = true, classContext = null) =>
    apiCall(`/code-editor/projects/${projectId}/unarchive`, {
      method: 'PUT',
      body: JSON.stringify({
        class_id: classContext?.class_id,
        unarchive_files: unarchiveFiles
      })
    }, classContext),

  // TA/Instructor endpoints for viewing student work
  getStudentProjects: (studentUsername, classContext = null) =>
    apiCall(`/code-editor/admin/students/${studentUsername}/projects?class_id=${classContext?.class_id}`, {
      method: 'GET'
    }, classContext),

  getStudentFile: (studentUsername, fileId, classContext = null) =>
    apiCall(`/code-editor/admin/students/${studentUsername}/files/${fileId}?class_id=${classContext?.class_id}`, {
      method: 'GET'
    }, classContext),

  getClassStudentsOverview: (classId, classContext = null) =>
    apiCall(`/code-editor/admin/class/${classId}/students`, {
      method: 'GET'
    }, classContext),

  // Code execution logging
  logCodeExecution: (logData, classContext = null) =>
    apiCall(`/code-editor/execution-log?class_id=${classContext?.class_id}`, {
      method: 'POST',
      body: JSON.stringify(logData)
    }, classContext),

  getExecutionStats: (classContext = null) =>
    apiCall(`/code-editor/execution-stats?class_id=${classContext?.class_id}`, {
      method: 'GET'
    }, classContext),

  getExecutionLogs: (limit = 50, skip = 0, classContext = null) =>
    apiCall(`/code-editor/execution-logs?class_id=${classContext?.class_id}&limit=${limit}&skip=${skip}`, {
      method: 'GET'
    }, classContext)
};